<div id="services" class="container-fluid mt-5"
  style="padding-top: 6%; background-image: url('../../../../../assets/backgrounds/bg2.svg'); background-size: contain; background-position: center; background-repeat: no-repeat;">
  <div class="row">
    <div class="col-4 offset-1 text-white user-select-none">
      <h6 class="font-brand-secondary" style="display: inline; clear: none;">NUESTROS </h6>
      <h6 class="font-brand-secondary text-brand" style="display: inline; clear: none;">PRINCIPALES SERVICIOS</h6>
      <h5 class="font-brand">VARIEDAD DE SERVICIOS ENFOCADOS A CUMPLIR TODAS TUS NECESIDADES</h5>
      <div class="row mt-4">
        <div class="col-11 text-right text-white" style="z-index: 1040 !important;">
          <a class="btn btn-lg btn-brand px-4" type="submit" [routerLink]="['/inicio']" [fragment]="'contact'" 
            style="font-size: 13px; font-weight: 500;">HAZ TU COTIZACIÓN</a>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="d-flex justify-content-center bd-highlight text-white">
        <div class="col-3">
          <app-shared-card-service [img]="'../../../../../assets/services/seguridad-informatica.svg'"
            [title]="'Seguridad Informática'" [nro]=0 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
            [topics]="['Seguridad de red','Seguridad de software','Auditorias','Pentesting']">
          </app-shared-card-service>
        </div>
        <div class="col-3">
          <app-shared-card-service [img]="'../../../../../assets/services/diseno-uiux.svg'" [title]="'Diseño UI/UX'"
            [nro]=1 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
            [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
          </app-shared-card-service>
        </div>
        <div class="col-3">
          <app-shared-card-service [img]="'../../../../../assets/services/paginas-web.svg'"
            [title]="'Páginas y App Web'" [nro]=2 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
            [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
          </app-shared-card-service>
        </div>
        <div class="col-3">
          <app-shared-card-service [img]="'../../../../../assets/services/aplicaciones-moviles.svg'"
            [title]="'Aplicaciones Móviles'" [nro]=3 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
            [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
          </app-shared-card-service>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-10 offset-1">
      <div class="d-flex flex-row-reverse bd-highlight text-white">
        <div class="col-7">
          <div class="d-flex bd-highlight">
            <div class="col-3">
              <app-shared-card-service [img]="'../../../../../assets/services/ecommerce.svg'"
                [title]="'Comercio Electrónico'" [nro]=4 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
                [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
              </app-shared-card-service>
            </div>
            <div class="col-3">
              <app-shared-card-service [img]="'../../../../../assets/services/arquitecturas-de-datos.svg'"
                [title]="'Arquitectura de datos'" [nro]=5 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
                [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
              </app-shared-card-service>
            </div>
            <div class="col-3">
              <app-shared-card-service [img]="'../../../../../assets/services/inteligencia-artificial.svg'"
                [title]="'Ciencia de Datos'" [nro]=6 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
                [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
              </app-shared-card-service>
            </div>
            <div class="col-3">
              <app-shared-card-service [img]="'../../../../../assets/services/microcontroladores-iot.svg'"
                [title]="'Dispositivos IOT'" [nro]=7 [header]="'Lorem ipsum dolor sit amet, consectetur adipiscing'"
                [topics]="['ipsum dolor','ipsum dolor','ipsum dolor','ipsum dolor']">
              </app-shared-card-service>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>